module.exports = __webpack_public_path__ + "static/tactics_collection_hokej-a78a0a6908dda894818abbc1d5b08ecb.mp4";